import styles from './style.module.scss';
import React, { useState } from 'react';
import { launchToast } from '../../utils';
import { img_logo } from '../../assets';
import { AUTH_API } from '../../api-handle/modules/auth.api';
import { useAppContext } from '../../context';
import { LOCALSTORAGE_TOKEN_LABEL } from '../../constants';
import { Link } from 'react-router-dom';

/**
 * Login component:
 * Standar login component for the application.
 */
export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { setUser } = useAppContext();

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      let res1 = await AUTH_API.login(email, password);
      let res2 = await AUTH_API.checkSession(res1.token);
      if (res2?.data?.role === 'annotator') {
        launchToast.success('Login Successful!');
        setUser(res2.data);
        window.localStorage.setItem(LOCALSTORAGE_TOKEN_LABEL, res1.token);
      } else {
        launchToast.error('Invalid Credentials!');
      }
    } catch (error) {
      launchToast.error('Invalid Credentials!');
    }
    clearFields();
    setIsLoading(false);
  };

  const clearFields = () => {
    setEmail('');
    setPassword('');
  };

  return (
    <div className={`${styles.Login} h-100vh`}>
      <div className="container h-100 d-flex justify-content-center align-items-center">
        <div
          className="card p-4 py-4 w-100 shadow rounded-15"
          style={{ maxWidth: '450px' }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={img_logo}
              alt="logo"
              className="img-fluid mb-5"
              width={200}
            />
          </div>
          <form
            className="w-100 d-flex flex-column justify-content-center align-items-start gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            <div className="fw-bold">Email</div>
            <input
              type="email"
              className="form-control w-100"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="fw-bold">Password</div>
            <input
              type="password"
              className="form-control w-100"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="pt-2 d-flex justify-content-center align-items-center w-100">
              <button
                type="submit"
                className="btn btn-primary px-4 "
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="spinner-grow text-light small spinner-grow-sm"></div>
                ) : (
                  <div className="fw-bold">Login</div>
                )}
              </button>
            </div>
          </form>
          <br />
          <Link to={'/forgot-password'}>
            <div className="link-primary">
              <small className="fw-bold">Forgot Password?</small>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
